module.exports = __webpack_public_path__ + "assets/img/chevron-right.6e394d8a.svg";